<template>
  <section class="app-review">
    <div class="app-review__header">
      <router-link
        :to="{ name: 'DoctorAppIntegrationEducation' }"
        class="btn btn-primary app-review__go-back"
        tag="button"
      >
        <i class="icon icon-arrow-left" />
        Editar informações
      </router-link>
    </div>

    <header class="app-review__header !justify-center">
      <h4 class="app-review__title !text-2xl">
        Obrigado por entrar no Marketplace Dr. Conecta,
        <br>
        onde o nosso propósito se conecta à sua agenda.
      </h4>
    </header>

    <article class="app-review__wrapper !items-center !justify-center">
      <p class="app-review__subtitle text-center">
        Agora você conta com o seu link próprio para pacientes particulares.
        <br>
        Além disso, você já está integrado e pronto para receber novos
        clientes do Marketplace.
      </p>

      <button
        class="btn btn-primary app-review__call-to-action"
        @click="openAgendaOnline"
      >
        Minha agenda online
      </button>

      <p class="app-review__subtitle text-center mt-16">
        <strong>Lembre-se:</strong> Caso tenha alguma indisponibilidade para
        os atendimentos, <br> é imprescindível que faça o bloqueio de sua agenda
        para evitar que pacientes <br>façam o agendamento e você não possa atendê-los.
      </p>

      <p class="app-review__subtitle text-center">
        Vá até a agenda e clique no icone do cadeado <img :src="require('@/assets/img/lock.png')" class="inline">
        no canto superior direito
        <br> para fazer o bloqueio se necessário.
      </p>
    </article>

    <footer class="app-review__footer !items-center !justify-center !content-center">
      <div class="app-review__footer-col">
        <router-link
          :to="{ name: 'DoctorAgenda' }"
          class="btn btn-blue app-review__call-to-action"
          tag="button"
        >
          Voltar para agenda
        </router-link>
      </div>
    </footer>
  </section>
</template>

<script>
import EventBus from '@/globals/eventBus'

export default {
  name: 'AppIntegrationReview',

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data () {
    return {
      isLoading: false,
      profilePicture: null,
      doctorInfo: {}
    }
  },

  created () {
    this.isLoading = true
    this.fn_SHOW_PROGRESS()

    this.getDoctor()
      .then(res => this.buildDoctorInfo(res.data))
      .then(this.getAppIntegration)
      .then(this.getPresentation)
      .then(res => (this.doctorInfo.presentation = res.data))
      .catch(err => console.log(err))
      .finally(() => {
        this.isLoading = false
        this.fn_HIDE_PROGRESS()
      })

    this.profilePicture = this.doctor.user.gender === 'F'
      ? require('@/assets/img/f_default.png')
      : require('@/assets/img/m_default.png')

    this.getProfilePicture()
  },

  methods: {
    buildDoctorInfo (doctor) {
      this.doctorInfo = {
        name: `Dr${
          (doctor.user.gender === 'F') ? 'a' : ''
        }. ${
          doctor['display_name'] || doctor.user['name']
        }`,
        crm: `${doctor['crm']}/${doctor['crm_regional']}`,
        isAmbEspecialization: doctor['is_amb_especialization'],
        medicalSpecialties: doctor['medical_specialties'].map(s => s.name),
        specializationCourses: doctor['specialization_courses'].map(c => c.name),
        university: {
          name: doctor['university'],
          start: doctor['university_start_date'],
          end: doctor['university_end_date']
        },
        address: {
          street: doctor['doctor_offices'][0].address.street,
          number: doctor['doctor_offices'][0].address.number,
          district: doctor['doctor_offices'][0].address.district,
          city: doctor['doctor_offices'][0].address.city.name,
          uf: doctor['doctor_offices'][0].address.uf.name
        }
      }

      return true
    },

    getDoctor () {
      return this.$http
        .get('/doctor', this.$store.getters.getAuthHeader)
    },

    getPresentation () {
      return this.$http
        .get('/doctor/presentation', this.$store.getters.getAuthHeader)
    },

    getProfilePicture () {
      const url = `/s3/file/doctor/${this.doctor.id}/profile_picture`
      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then(() => (this.profilePicture = `${process.env.ROOT_API}${url}`))
        .catch(() => {
          this.profilePicture = this.doctor.user.gender === 'F'
            ? require('@/assets/img/f_default.png')
            : require('@/assets/img/m_default.png')
        })
    },

    getAppIntegration () {
      return new Promise((resolve, reject) => {
        this.$http
          .get('/doctor/app_integration', this.$store.getters.getAuthHeader)
          .then((res) => {
            this.$store.dispatch('setAppIntegration', res.data['app_integration'])
            resolve()
          })
      })
    },

    openAgendaOnline () {
      EventBus.$emit('open-agenda-online-controls')
    }
  }
}
</script>
